(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tfs-platter-review-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const selectImage = (button) => {
    const gallery = button.closest('.tfs-review-gallery');
    const image = gallery.querySelector('.tfs-review-gallery__image');
    image.src = button.dataset.image;
    image.alt = button.dataset.caption;
    gallery.querySelector('.tfs-review-gallery__large').href = button.dataset.image;
    gallery.querySelector('.tfs-review-gallery__caption').textContent = button.dataset.caption;
    gallery.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.tfs-review-gallery__thumbs button');
    if (button) selectImage(button);
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('input[type="radio"]')) return;
    const id = input.value === 'Standard Recipe' ? '45721768493125' : input.value === 'Landscape Recipe' ? '45721768460357' : input.value === 'Portrait / Vertical Child Artwork' ? '45864476180549' : input.value === 'Wide / Landscape Child Artwork' ? '45887466012741' : null;
    if (!id) return;
    const button = document.querySelector('.tfs-review-gallery button[data-variant="' + id + '"]');
    if (button) selectImage(button);
  });
  const variant = new URL(location.href).searchParams.get('variant');
  if (variant) {
    const button = document.querySelector('.tfs-review-gallery button[data-variant="' + variant + '"]');
    if (button) selectImage(button);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
